import { useState } from 'react'
import { RecurringExpirationType } from "./RecurringExpirationType";

const PointsExpiration = ({ pointType, pointExpiration }) => {


  const today = new Date();
  const [ expirationType, setExpirationType ] = useState( pointExpiration['type']?? 'none' )

  const expirationTypeField = tangibleFields.render({
    type: 'select',
    //name: `${pointType.id}-point_expiration_type`,
    name: `point_expirations[${pointType.id}][type]`,
    label: 'Expiration type',
    choices: { 'none': 'None', 'recurring': 'Recurring', 'scheduled': 'Scheduled' },
    value: expirationType
  })

  const months = {
    1: 'January',
    2: 'February',
    3: 'March',
    4: 'April',
    5: 'May',
    6: 'June',
    7: 'July',
    8: 'August',
    9: 'September',
    10: 'October',
    11: 'November',
    12: 'December'
  }

  const scheduledFieldGroup = tangibleFields.render({
    type: 'repeater',
    name: `point_expirations[${pointType.id}][schedule]`,
    value: pointExpiration['schedule'],
    layout: 'table',
    fields: [
      { type: 'number', name: 'year', label: 'Year', minValue: 2000 },
      { type: 'select', name: 'month', label: 'Month', choices: months },
      { type: 'number', name: 'day', label: 'Day', minValue: 1, maxValue: 31 }
    ]
  })

  tangibleFields.event('valueChange', field => {
    if ( field.name === `point_expirations[${pointType.id}][type]` ) setExpirationType(field.value)
  })

  return (
    <div className="tf-points-expiration">
      <div className="header">
        <span className="tf-point-type">{pointType.label}</span>
        { expirationTypeField }
      </div>
      { expirationType !== 'none' && <div className="body">
        { expirationType === 'scheduled' ? scheduledFieldGroup : <RecurringExpirationType pointType={pointType} pointExpiration={pointExpiration}/> }
      </div> }
    </div>
  )
}

export { PointsExpiration }
